import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  savedEmail: string;
  setSavedEmail: (email: string) => void;
  clearSavedEmail: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      savedEmail: "",
      setSavedEmail: (email: string) => set({ savedEmail: email }),
      clearSavedEmail: () => set({ savedEmail: "" }),
    }),
    {
      name: "morpheus-email-storage",
    },
  ),
);
